<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    stroke="currentColor"
    fill="currentColor"
    xml:space="preserve"
  >
    <path
      d="M340.4,295c-5.8,20.3-57.8,35.8-86.1,37.6v-121h-9.6v121c-28.2-1.7-80.2-17.4-85.9-37.6
	c-3-10.4,22.3-39.4,41.2-56.6l6.3-5.7l-8-2.4c-8-2.3-16.2-6.3-17.2-8c-5.2-22.4,45-75.7,68.6-98.1c23.6,22.4,73.8,75.7,68.7,97.9
	c-1.2,2-9.4,5.9-17.3,8.2l-8,2.4l6.3,5.7C318.1,255.6,343.3,284.6,340.4,295 M311.4,236.8c7.2-2.8,14.9-7,15.9-12.3
	c7.7-33.1-66.2-102.6-74.7-110.4l-3.1-3l-3.2,3c-8.4,8-82.4,77.3-74.7,110.4c1.2,5.3,8.9,9.4,15.9,12.3
	c-13.9,13.6-42.8,44.1-38,60.9c8,27.4,67.1,42.8,95.1,44.5v46.4h9.6v-46.5c27.9-1.7,87.6-17.1,95.3-44.5
	C354.4,280.8,325.5,250.4,311.4,236.8"
    />
  </svg>
</template>
